export const CONFIG = {
  baseurl: 'http://localhost:3000',
  cidaas:
    'https://rehau-free.cidaas.de/authz-srv/authz?client_id=60bd43ec-6d5f-4acc-9e7b-007030bb4d80&response_type=token&nonce=12345&response_mode=query&scope=openid%20profile%20email%20roles&redirect_uri=',
  cidaas_revoke:
    'https://rehau-free.cidaas.de/session/end_session?access_token_hint=',
  env: 'local',
  appUrl: 'http://localhost:4200'
};
